import React from 'react';
import { ArrowRight } from 'lucide-react';
import { networkSection, trendSection } from '../mockData';
import { Button } from './ui/button';

const FeaturedSections = () => {
  return (
    <>
      {/* Network Section */}
      <section className="py-16 bg-[#0A1F3B] text-white">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="flex-1">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                {networkSection.title}
              </h2>
              <p className="text-lg text-white/90 mb-8 leading-relaxed">
                {networkSection.description}
              </p>
              <Button 
                className="bg-[#00ACC1] hover:bg-[#0097A7] text-white px-8 py-6 text-base group"
              >
                {networkSection.link}
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
            <div className="flex-1">
              <img
                src={networkSection.image}
                alt="Network"
                className="w-full rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Trend Section */}
      <section className="py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-12">
            <div className="flex-1">
              <h2 className="text-3xl lg:text-4xl font-bold text-[#0A1F3B] mb-6">
                {trendSection.title}
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                {trendSection.description}
              </p>
              <Button 
                className="bg-[#0A1F3B] hover:bg-[#0A1F3B]/90 text-white px-8 py-6 text-base group"
              >
                {trendSection.link}
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
            <div className="flex-1">
              <img
                src={trendSection.image}
                alt="Trends"
                className="w-full rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeaturedSections;